<template lang="pug">
  img.gl-group-logo(src="~@/assets/icons/default-group.svg")
</template>

<script>
import $ from 'jQuery'
import _ from 'lodash'

export default {

  // props
  props: {
    domain: String,
    groupId: Number
  },

  // watch
  watch: {
    domain () {
      this.setSrc()
    },
    groupId () {
      this.setSrc()
    }
  },

  // on mount
  mounted () {
    // img will have a current + fallback src
    let src = { current: '', fallback: '' }

    // declare $el
    let $el = $(this.$el)

    // set current src
    src.current = $el.attr('src')

    // if current src looks like the fallback src
    if (_.isString(src.current) && src.current.startsWith('data:image/svg')) {
      // set fallback src
      src.fallback = src.current
    }

    // on error
    $el.bind('error', () => {
      // set src to fallback src
      $el.attr('src', src.fallback)
    })

    // set src
    this.setSrc()

    // on config commit -> set src
    this.$glEventHub.$on('store.config.commit', () => {
      this.setSrc()
    })
  },

  // methods
  methods: {
    setSrc () {
      // declare $el
      let $el = $(this.$el)

      if (this.groupId) {
        // set group config
        const GROUP_CONFIG = this.$store.getters.config['gid_' + this.groupId] || {}

        // if group config has a domain -> use it for the src
        if (GROUP_CONFIG.domain) $el.attr('src', '//logo.clearbit.com/' + GROUP_CONFIG.domain)

        // if group config has an image -> use it for the src
        if (GROUP_CONFIG.image) $el.attr('src', GROUP_CONFIG.image)

        // if group config request hideImage -> hide image
        if (GROUP_CONFIG.hideImage === 'true' && this.$route.name === 'dashboard') {
          $el.hide()
        } else if (!$el.is(':visible')) {
          $el.show()
        }
      } else if (this.domain) {
        // if group config has a domain -> use it for the src
        $el.attr('src', '//logo.clearbit.com/' + this.domain)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/gl-group-logo.vue